"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    RadioWithLabel: ()=>RadioWithLabel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../../Image/index.cjs");
const external_Label_index_cjs_namespaceObject = require("../../Label/index.cjs");
const Radio_variants_cjs_namespaceObject = require("../RadioButton/Radio.variants.cjs");
const RadioButton_cjs_namespaceObject = require("../RadioButton/RadioButton.cjs");
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
function RadioWithLabel(props) {
    const { labelClassName, radioButtonClassName, labelProps = {}, labelNode, disabled, emphasis, size = '20', value, name, iconLeft, textStyle = 'body2', helperText = '', textRight = '', imageSrc = '', maxWidth = 24, height = 6 } = props;
    const { labelSlot, iconSlot, helperSlot, imageSlot, containerSlot, textRightSlot } = (0, Radio_variants_cjs_namespaceObject.radioButtonVariants)({
        emphasis,
        size,
        disabled
    });
    const iconSlotClasses = iconSlot();
    const iconSize = textStyleIconSizes[textStyle] ?? '20';
    const labelClasses = (0, index_cjs_namespaceObject.cn)(labelSlot(), labelClassName);
    const textRightClasses = textRightSlot();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Label_index_cjs_namespaceObject.Label, {
        className: labelClasses,
        ...labelProps,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RadioButton_cjs_namespaceObject.RadioButton, {
                radioButtonClassName: radioButtonClassName,
                disabled: disabled,
                emphasis: emphasis,
                size: size,
                value: value,
                name: name
            }),
            iconLeft && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: containerSlot(),
                children: [
                    labelNode,
                    helperText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                        className: helperSlot(),
                        children: helperText
                    })
                ]
            }),
            imageSrc && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: imageSlot(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                    src: imageSrc,
                    alt: "image",
                    maxWidth: maxWidth,
                    height: height,
                    objectFit: "contain",
                    objectPosition: "center"
                })
            }),
            textRight && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("span", {
                className: textRightClasses,
                children: [
                    "(",
                    textRight,
                    ")"
                ]
            })
        ]
    });
}
exports.RadioWithLabel = __webpack_exports__.RadioWithLabel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "RadioWithLabel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
